import { TFunction } from 'i18next';
import React from 'react';

import { Button, ButtonEnums } from '../../components';

interface Action {
	label: string;
	onClick: () => void;
	disabled?: boolean;
}

interface ActionButtonsProps {
	actions: Action[];
	disabled?: boolean;
	t?: TFunction;
}

function ActionButtons({ actions, disabled = false, t }: ActionButtonsProps) {
	return (
		<React.Fragment>
			{actions.map((action, index) => (
				<Button
					key={index}
					onClick={action.onClick}
					disabled={disabled || action.disabled}
					type={ButtonEnums.type.secondary}
					size={ButtonEnums.size.small}
					className={index > 0 ? 'ml-2' : ''}
				>
					{t ? t(action.label) : action.label}
				</Button>
			))}
		</React.Fragment>
	);
}

export default ActionButtons;
